// extracted by mini-css-extract-plugin
module.exports = {"content":"e_i6","opened":"e_j6","buttonIcon":"e_k6","buttonIconOpen":"e_l6","toggle":"e_m6","collapsible":"e_n6"};